export default "__VITE_ASSET__218564e1__"